/**
 * Integration between Color Selector and Add to Cart Button
 * Author: TiaanPepper
 * Date: 2025-04-12 01:58:42
 * 
 * This script ties the color selector with the add to cart button
 * to implement the required functionality:
 * - Redirect to cart page when custom colors are selected
 * - Open cart drawer when all standard colors are selected
 * - Show product description with variant selection in cart
 * - Support for four-color mode (Primary, Top, Middle, Bottom)
 */

document.addEventListener('DOMContentLoaded', function() {
  // Check for window.colorState from the color selector script
  if (!window.colorState) {
    // Check if we have a color selector with four-color mode
    const colorSelector = document.querySelector('[data-color-selector]');
    const selectionMode = colorSelector ? colorSelector.getAttribute('data-selection-mode') || 'double' : 'double';
    
    // Initialize color state if it doesn't exist yet
    window.colorState = {
      currentSelection: selectionMode === 'four' ? 'primary' : 'top',
      primaryColor: null,
      topColor: null,
      middleColor: null,
      bottomColor: null,
      customColorCount: 0,
      lastEditedSelection: selectionMode === 'four' ? 'primary' : 'top',
      hasAttemptedAddToCart: false,
      selectionMode: selectionMode,
      hasFourColorMode: selectionMode === 'four',
      // Store position labels for reference
      positionLabels: {
        'primary': 'Primary Color',
        'top': 'Top Feather',
        'middle': 'Middle Feather',
        'bottom': 'Bottom Feather'
      }
    };
  }
  
  // Function to update the add to cart button state based on color selection
  function updateAddToCartButtonState() {
    const addToCartButton = document.querySelector('button[type="submit"][name="add"]');
    if (!addToCartButton) return;
    
    // Check the selection mode
    const colorSelector = document.querySelector('[data-color-selector]');
    if (!colorSelector) return;
    
    const selectionMode = colorSelector.getAttribute('data-selection-mode') || 'double';
    
    // Ensure these are set in the colorState
    window.colorState.selectionMode = selectionMode;
    window.colorState.hasFourColorMode = selectionMode === 'four';
    
    // Check if we have valid color selections based on the mode
    let hasValidSelection = true;
    
    if (selectionMode === 'four') {
      hasValidSelection = window.colorState.primaryColor && 
                          window.colorState.topColor && 
                          window.colorState.middleColor && 
                          window.colorState.bottomColor;
    } else if (selectionMode === 'single') {
      hasValidSelection = !!window.colorState.topColor;
    } else if (selectionMode === 'double') {
      hasValidSelection = window.colorState.topColor && window.colorState.bottomColor;
    } else if (selectionMode === 'triple') {
      hasValidSelection = window.colorState.topColor && 
                          window.colorState.middleColor && 
                          window.colorState.bottomColor;
    }
    
    // DON'T disable the button even if selection is invalid - let the validation show errors
    // We'll allow the add to cart attempt and show appropriate error messages
    addToCartButton.removeAttribute('disabled');
    addToCartButton.classList.remove('disabled');
    
    // Count custom colors for button text update
    let customCount = 0;
    
    if (selectionMode === 'four') {
      if (window.colorState.primaryColor && window.colorState.primaryColor.isCustom) customCount++;
      if (window.colorState.topColor && window.colorState.topColor.isCustom) customCount++;
      if (window.colorState.middleColor && window.colorState.middleColor.isCustom) customCount++;
      if (window.colorState.bottomColor && window.colorState.bottomColor.isCustom) customCount++;
    } else {
      if (window.colorState.topColor && window.colorState.topColor.isCustom) customCount++;
      if (selectionMode === 'triple' && window.colorState.middleColor && window.colorState.middleColor.isCustom) customCount++;
      if ((selectionMode === 'double' || selectionMode === 'triple') && 
          window.colorState.bottomColor && window.colorState.bottomColor.isCustom) customCount++;
    }
    
    window.colorState.customColorCount = customCount;
    
    // Update the text to show if custom colors are selected
    const buttonTextSpan = addToCartButton.querySelector('.btn-text span');
    if (buttonTextSpan) {
      if (customCount > 0) {
        buttonTextSpan.textContent = 'Add with Custom Color';
      } else {
        buttonTextSpan.textContent = 'Add to cart';
      }
    }
    
    // Also update the error message visibility
    const errorMessage = document.getElementById('cs-color-error-message');
    if (errorMessage) {
      if (window.colorState.hasAttemptedAddToCart && !hasValidSelection) {
        errorMessage.style.display = 'block';
      } else {
        errorMessage.style.display = 'none';
      }
    }
  }
  
  // Listen for changes to the color state
  const originalUpdateColorSelection = window.updateColorSelection;
  if (typeof originalUpdateColorSelection === 'function') {
    window.updateColorSelection = function(colorName, colorCode, isCustom) {
      // Call the original function
      originalUpdateColorSelection(colorName, colorCode, isCustom);
      
      // Update the add to cart button state
      updateAddToCartButtonState();
    };
  }
  
  // Initial update of the button state
  setTimeout(updateAddToCartButtonState, 300);
  
  // Also listen for variant changes
  document.addEventListener('variant:change', function() {
    updateAddToCartButtonState();
  });
});